import { useEffect, useState } from "react";

export const useIsLg = () => {
  const [isLg, setIsLg] = useState(() => window.innerWidth >= 1024);

  useEffect(() => {
    const handler = () => setIsLg(window.innerWidth >= 1024);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return isLg;
};